import siteApiV4 from "../clients/site-api-v4";
export const generateSiteMeilisearchKey = async (): Promise<string> => {
  const { data } = await siteApiV4.post<string>("/generate-search-key");

  return data;
};
